import { Box, Button, Collapse, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import { CommonPatientDetails, DeletePopup } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import { getCachevalue, localGetItem, setCachevalue } from '../../../Utility/Services/CacheProviderService'
import { CurrencySymbol } from '../../../Utility/Constants'
import { AmountFormat, ContentInTooltip } from '../../../Components/CommonFunctions/CommonFunctions'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import { ImagePaths } from '../../../Utility/ImagePaths'
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";

const DocDraft = () => {
    const [states, setStates] = useState({
        patientDetails: {},
        clinic_id: null,
        appointment_id: null,
        patient_id: null,
        doctor_id: null,
        selectedIndex: null,
        draftBillData: [],
        openDeletePopup: false,
        removeData: false,
        selectedDeleteData: null
    })
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })
    let history = useHistory()

    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: message,
            transmit: false,
            saveLoad: false
        })
    }

    const successMessage = (message) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: message,
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }
    const loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo'))

    // API STARTS ===> 

    useEffect(() => {
        const clinicId = getCachevalue('SelectedDoctorClinic');
        const appointmentData = JSON.parse(getCachevalue('DoctorPatientData'));

        const updateStates = {
            clinic_id: clinicId,
            appointment_id: appointmentData?.appointment_id,
            patient_id: appointmentData?.patient_id,
            doctor_id: appointmentData?.doctor_id,
            patientDetails: appointmentData,
        };

        setStates((prev) => ({ ...prev, ...updateStates }));
        getPatientDetailData(updateStates.patient_id);
        getDraftBillData(updateStates.patient_id);
    }, [])

    const getPatientDetailData = (patient_id) => {
        try {
            RestAPIService.getAll(Serviceurls.DOC_PATIENT_DETAIL_GET + '?patient_id=' + patient_id)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setStates((prev) => ({ ...prev, patientDetails: {...prev.patientDetails, ...response?.data?.data} }))
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getDraftBillData = (patient_id) => {
        try {
            RestAPIService.getAll(Serviceurls.NEW_FO_PATIENT_APPOINTMENT_SAVED_GET + "?patient_id=" + patient_id)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setStates((prev) => ({ ...prev, draftBillData: response?.data?.data }))
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const deleteSavedBillData = () => {
        try {
            let data = {
                id: states.selectedDeleteData?.id,
            }
            setStates((prev) => ({ ...prev, removeData: true }))
            RestAPIService.delete(Serviceurls.NEW_COMPLETE_BILLS_GET, data)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        successMessage(response?.data?.message)
                        getDraftBillData(states.patient_id)
                        popupClose()
                        setStates((prev) => ({ ...prev, removeData: false }))
                    }
                }).catch((error) => {
                    setStates((prev) => ({ ...prev, removeData: false }))
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            setStates((prev) => ({ ...prev, removeData: false }))
            errorMessage(error.message)
        }
    }

    // API ENDS =====>

    const popupClose = () => {
        try {
            setStates((prev) => ({
                ...prev,
                selectedDeleteData: null,
                openDeletePopup: false
            }))
        } catch (err) {
            errorMessage(err.message)
        }
    }

    const renderDraftTable = () => {
        try {
            return (
                <Box component={'div'} sx={{ backgroundColor: Colors.white }}>
                    <Table aria-label="collapsible table" stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell className='eMed_Pat_Bill_Tbl_Header' />
                                <TableCell className='eMed_Pat_Bill_Tbl_Header'>{("Appointment Number And Date")}</TableCell>
                                <TableCell className='eMed_Pat_Bill_Tbl_Header' align='right'>{("No Of Bill")}</TableCell>
                                <TableCell className='eMed_Pat_Bill_Tbl_Header' align='center'>{`${("Total Bill Amount")} (${CurrencySymbol})`}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {states.draftBillData?.length > 0 ? states.draftBillData?.map((item, index) => (
                                <><TableRow
                                    sx={{ backgroundColor: states.selectedIndex === index ? Colors?.ThemeLightColor : 'white', cursor: "pointer" }}
                                    key={index}
                                    onClick={() => { setStates((prev) => ({ ...prev, selectedIndex: states.selectedIndex === index ? null : index })) }}>
                                    <TableCell className='eMed_Pat_Tbl_one_style'>
                                        <IconButton
                                            size='small'
                                            onClick={() => { setStates((prev) => ({ ...prev, selectedIndex: states.selectedIndex === index ? null : index })) }}
                                        >
                                            {states.selectedIndex === index ?
                                                <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                        </IconButton>
                                    </TableCell>
                                    <TableCell className='eMed_Pat_Tbl_one_style'>{`${item?.op_number ? item?.op_number : "-"}
                                     | ${item?.appointment_date ? item?.appointment_date : "-"}`}</TableCell>
                                    <TableCell className='eMed_Pat_Tbl_one_style' align='right'>{item?.no_of_bills ? item?.no_of_bills : "-"}</TableCell>
                                    <TableCell className='eMed_Pat_Tbl_one_style' align='center'>{item?.total_bill_amount ? AmountFormat(item?.total_bill_amount)?.replace(`${CurrencySymbol}`, "") : "-"}</TableCell>
                                </TableRow>
                                    <TableRow>
                                        {renderTableOne(item, index)}
                                    </TableRow></>
                            )) : <TableRow><TableCell align='center' colSpan={4}>No Records To Be Shown</TableCell>
                            </TableRow>}
                        </TableBody>
                    </Table>
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getCapitalize = (data) => {
        const capitalized = data.charAt(0).toUpperCase() + data.slice(1);
        return capitalized;
    }

    const renderTableOne = (item, index) => {
        const billedFromToModuleMap = {
            FO: 'front_office',
            DOCTOR: 'Doctor',
            LAB: 'Laboratory',
            RADIOLOGY: 'Radiology',
            PHARMACY: 'Pharmacy',
            CANTEEN: 'Canteen'
          };
        return (
            <><TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
                <Collapse in={states.selectedIndex === index} timeout={'auto'}>
                    <Box margin={1} className='eMed_Pat_Bill_Tbl_Two'>
                        <Table>
                            <TableHead sx={{ backgroundColor: Colors.Background }}>
                                <TableRow>
                                    <TableCell className='eMed_Pat_Bill_Tbl_Header'>{("Date And Time")}</TableCell>
                                    <TableCell className='eMed_Pat_Bill_Tbl_Header'>{("Bill Number")}</TableCell>
                                    <TableCell className='eMed_Pat_Bill_Tbl_Header'>{("Bill Type")}</TableCell>
                                    <TableCell className='eMed_Pat_Bill_Tbl_Header' align='center'>{("Module")}</TableCell>
                                    <TableCell className='eMed_Pat_Bill_Tbl_Header'>{("Doctor/Nurse Name")}</TableCell>
                                    <TableCell className='eMed_Pat_Bill_Tbl_Header' align='right'>{`${("TotalBillAmount")} (${CurrencySymbol})`}</TableCell>
                                    <TableCell className='eMed_Pat_Bill_Tbl_Header' align='center'>{getCachevalue("isForCancelBill") === "true" ? "" : ("Action")}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {item.bill_detail?.length > 0 ? item?.bill_detail.map((i, subIndex) => {
                                    let billType = i?.bill_type ? getCapitalize(i.bill_type) : "-";
                                    return (
                                        <TableRow key={subIndex}>
                                            <TableCell className='eMed_Pat_Tbl_one_style'>{i?.invoice_date ? i.invoice_date : '-'}</TableCell>
                                            <TableCell className='eMed_Pat_Tbl_one_style'>{i?.bill_number ? i.bill_number : '-'}</TableCell>
                                            <TableCell className='eMed_Pat_Tbl_one_style'>{billType ? billType : '-'}</TableCell>
                                            <TableCell className='eMed_Pat_Tbl_one_style'>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
                                                    <Typography textTransform={'capitalize'} component={'div'} fontSize={"0.8rem"} > {i?.module ? i.module : '-'}</Typography>
                                                    <Typography textTransform={'capitalize'} component={'div'} fontSize={"0.8rem"} >{
                                                        (i?.module === "PHARMACY" && localGetItem("multiPharmacy") === "true") ? ContentInTooltip(i?.pharmacy_name ? i?.pharmacy_name : "-", 10, "0.8rem") :
                                                            (i?.module === "LAB" && localGetItem("multiLaboratory") === "true") ? ContentInTooltip(i?.laboratory_name ? i?.laboratory_name : "-", 10, "0.8rem") : ""}</Typography>
                                                </Box>
                                            </TableCell>
                                            <TableCell className='eMed_Pat_Tbl_one_style'>{i?.doctor_name ? i.doctor_name : i.nurse_name ? i.nurse_name : '-'}</TableCell>
                                            <TableCell className='eMed_Pat_Tbl_one_style' align='right'>{i?.total_amounts ? AmountFormat(i.total_amounts)?.replace(`${CurrencySymbol}`, "") : '-'}</TableCell>
                                            <TableCell className='eMed_Pat_Tbl_one_style' sx={{ flexDirection: 'row', justifyContent: 'center', display: 'flex', visibility: getCachevalue("isForCancelBill") === "true" ? "hidden" : "visible" }} align='center'>
                                                <Button className='eMed_Pat_tbl_two_btn' disabled={billedFromToModuleMap[i?.billed_from] !== loggedInUserInfo?.module_name}
                                                    onClick={() => {
                                                        setStates((prev) => ({ ...prev, opSavedBillId: i?.id }))
                                                        setCachevalue(true, 'isForCancelBill')
                                                        setCachevalue(true, 'FromOtherScreen')
                                                        setCachevalue('/DoctorHome/DoctorBilling', 'path')
                                                        history?.push({ pathname: '/DoctorBilling/DoctorBilling', state: { invoiceId: i?.id, fromPatientSavedBill: true, patientDetails: states.patientDetails, appointment_id: i?.appointment_id } })
                                                    }}
                                                >
                                                    <Tooltip placement='top' title={"Create Bill"} arrow>
                                                        <img
                                                            src={billedFromToModuleMap[i?.billed_from] !== loggedInUserInfo?.module_name ? ImagePaths.DisabledCreateBill.default : ImagePaths.CreateBill.default}
                                                            className='eMed_Pat_Bill_img'
                                                            alt='credit' />
                                                    </Tooltip>
                                                </Button>
                                                <Button className='eMed_Pat_tbl_two_btn' disabled={billedFromToModuleMap[i?.billed_from] !== loggedInUserInfo?.module_name} onClick={() => setStates((prev) => ({ ...prev, openDeletePopup: true, selectedDeleteData: i }))}>
                                                    <Tooltip placement='top' title={"Delete Bill"} arrow>
                                                        <img src={billedFromToModuleMap[i?.billed_from] !== loggedInUserInfo?.module_name ? ImagePaths.DisabledDelete.default : ImagePaths.Delete.default}
                                                            className='eMed_Pat_Bill_img'  alt='delete' />
                                                    </Tooltip>
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }) : <TableRow><TableCell align='center' colSpan={7}>No Records To Be Shown</TableCell></TableRow>}
                            </TableBody>
                        </Table>
                    </Box>
                </Collapse>
            </TableCell></>
        )
    }

    return (
        <Box component={'div'} sx={{ backgroundColor: Colors.Background, height: '75dvh' }}>
            <Box component={'div'}>
                <Box component={'div'} display={'flex'}>
                    <Box component={'div'} className='doc_header_card' ml={'0.5rem'}>
                        <CommonPatientDetails data={states.patientDetails} showDetailed={true} fromDoctor={true} />
                    </Box>
                </Box>
                <Box component={'div'} maxHeight={'64dvh'} border={'1px solid lightgray'} m={'0.5rem'} overflow={'auto'}>
                    {renderDraftTable()}
                </Box>
            </Box>
            {message.isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={message.isErrorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {message.successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={message.successMsgText}
                    msgPop={msgClose}
                />
                : null}
            {states.openDeletePopup ?
                <DeletePopup
                    DeletTitle={"Are you sure ? Do you want to delete this Saved bill ?"}
                    deleteAlertPopupClose={popupClose}
                    removeData={deleteSavedBillData}
                    ButtonText="Delete"
                    BillType="Saved Bill"
                    disable={states.removeData}
                /> : null}
        </Box>
    )
}

export default DocDraft